import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
	currentCurso: { label: 'Todos los cursos', value: null },
	key: null
};

const calendarioCursoSlice = createSlice({
	name: 'calendarioCursoState',
	initialState,
	reducers: {
		setCalendarioCursoState: (state, action) => {
			return action.payload;
		}
	}
});

export const { setCalendarioCursoState } = calendarioCursoSlice.actions;

export default calendarioCursoSlice.reducer;
